import { Injectable } from "@angular/core";
import { CriticalError } from 'core/error/error';

export class SVGValidationError extends CriticalError
{
  protected _name: string = 'SVGValidationError';
}

@Injectable()
export class SVGValidationService
{
  private svg: string;
  private svgDocument: Document;

  /**
   * @throws SVGValidationError
   */
  public validate(svg: string): boolean
  {
    this.svg = svg;
    this.parseSVGString();
    return true;
  }

  private parseSVGString(): void
  {
    let parseFailed = false;
    try {
      let parser = new DOMParser();
      this.svgDocument = parser.parseFromString(this.svg, 'image/svg+xml');
    } catch (ex) {
      parseFailed = true;
    } finally {
      // DOMParser schmeißt im Fehlerfall keine Exception, sondern liefert ein
      // Error document,
      // siehe https://bugzilla.mozilla.org/show_bug.cgi?id=45566
      if (parseFailed ||
          this.svgDocument.getElementsByTagName('parsererror').length > 0) {

        throw new SVGValidationError(`parsing of SVG string failed:
            ${this.svg}
            →
            ${this.getParserErrors(this.svgDocument)}`);
      }
    }
  }

  private getParserErrors(doc: Document): string
  {
    const errors = <Element[]><any>doc.getElementsByTagName('parsererror');

    let parserErrors = '';
    for (let err of errors) {
      parserErrors += err.innerHTML + '\n';
    }
    return parserErrors;
  }
}
